import { render, staticRenderFns } from "./en-gestion.vue?vue&type=template&id=747170a6&scoped=true"
import script from "./en-gestion.vue?vue&type=script&lang=ts"
export * from "./en-gestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747170a6",
  null
  
)

export default component.exports